import { GameCompletionData, GameCompletionHandler } from './game-completion-handler';

export class LoadingCompletionHandler implements GameCompletionHandler {
  endGameComplete(
    _data: GameCompletionData,
    _isComplete: boolean,
    _pauseGame: (pause: boolean) => void,
  ): Promise<void> {
    throw new Error('Invalid game completion.');
  }

  askGameUserFinish(_score: number): Promise<boolean> {
    throw new Error('Invalid game completion.');
  }

  endGameUserFinish(_data: GameCompletionData): Promise<void> {
    throw new Error('Invalid game completion.');
  }

  endGameDeadlineTimeout(
    _data: GameCompletionData,
    _pauseGame: (pause: boolean) => void,
  ): Promise<void> {
    throw new Error('Invalid game completion.');
  }
}
